
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/tinder",
      function () {
        return require("private-next-pages/android/local/tinder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/tinder"])
      });
    }
  